import styled from "styled-components";
import {baseDistance} from "../../styles/styles";
import {TitleStyled, WidgetRowStyled} from "./PortfolioList";
import type {IWidgetLink, IWidgetTitle} from "./HomeDashboard";

interface ILinksWidgetProps {
	readonly title: IWidgetTitle;
	readonly links: IWidgetLink[];
}

export const LinksWidget = (props: ILinksWidgetProps) => {
	const {title, links} = props;

	return (
		<NewFeaturesStyled>
			<TitleStyled $color={title.color}>{title.text}</TitleStyled>
			<ListStyled>
				{links.map((item, index) => (
					<div key={index}>
						<ListItemStyled>
							<a
								href={item.url}
								title={item.tooltip}
								target="_blank"
							>
								{item.displayText}
							</a>
						</ListItemStyled>
					</div>
				))}
			</ListStyled>
		</NewFeaturesStyled>
	);
};

const ListItemStyled = styled(WidgetRowStyled)`
	display: flex;
	justify-content: space-between;

	a {
		color: inherit;
	}

	&:hover svg {
		visibility: visible;
	}
`;

const ListStyled = styled.div`
	display: flex;
	flex-direction: column;
	overflow-y: auto;
`;

const NewFeaturesStyled = styled.div`
	height: 100%;
	width: 100%;
	padding: ${baseDistance.md};
	display: flex;
	flex-direction: column;
	gap: ${baseDistance.md};
`;
